import RepositoryService from 'src/services/repository'

const resource = 'operationCategory'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
}
